import { createStyles, makeStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      background:
        'transparent linear-gradient(230deg, #FFDC27 0%, #E63C3C 50%, #000A8C 100%) 0% 0% padding-box',
      height: '100vh',
      position: 'relative',
    },
    btnPrimary: {
      paddingLeft: 20,
      paddingRight: 20,
      background:
        'transparent linear-gradient(230deg, #FFDC27 0%, #E63C3C 50%, #000A8C 100%) 0% 0% no-repeat padding-box',
      color: '#fff',
      '@media(min-width: 1250px)': {
        paddingBottom: 10,
        paddingTop: 10,
        paddingLeft: 20,
        paddingRight: 20,
        minWidth: 146,
      },
      '@media only screen and (max-width: 600px)': {
        paddingBottom: 5,
        paddingTop: 5,
        paddingLeft: 10,
        paddingRight: 10,
        marginTop: 5,
      },
      display: 'block',
      marginTop: 30,
      width: '100%',
      textTransform: 'none',
    },
    textHeader: {
      display: 'block',
      '@media only screen and (max-width: 600px)': {
        fontSize: 10,
      },
    },
    paddingContent: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'flex-start',
      alignItems: 'center',
      width: '100%',
      paddingBottom: 50,
    },
    text: {
      width: '100%',
      fontFamily: 'Poppins',
      textAlign: 'left',
      color: '#FFFFFF',
      fontSize: '15px',
      marginTop: '0px',
      '@media only screen and (max-width: 600px)': {
        width: '90%',
        marginBottom: 5,
        fontSize: '14px',
      },
      '@media only screen and (max-width: 361px)': {
        width: '90%',
        marginBottom: 5,
        fontSize: '12px',
      },
      '& a': {
        color: '#fff !important',
      },
    },
    title: {
      textAlign: 'center',
      color: '#FFFFFF',
      fontFamily: 'Poppins',
      '@media only screen and (max-width: 600px)': {
        fontSize: '20px',
        marginTop: 10,
        marginBottom: 5,
      },
      '@media only screen and (max-width: 361px)': {
        marginTop: 0,
        marginBottom: 0,
      },
    },
    img: {
      borderRadius: '10px',
      width: 275,
      height: 275,
      '@media only screen and (max-width: 600px)': {
        width: 125,
        height: 125,
      },
      '@media only screen and (max-width: 361px)': {
        width: 100,
        height: 100,
      },
    },
    textH3: {
      width: '100%',
      color: 'white',
      fontFamily: 'Poppins',
      marginBottom: 30,
      textAlign: 'left',
      fontSize: '20px',
      textTransform: 'none',
      '@media only screen and (max-width: 600px)': {
        fontSize: '15px',
        marginBottom: 10,
        marginTop: 45,
      },
    },
    pie: {
      width: 300,
      height: 300,
      '@media only screen and (max-width: 600px)': {
        width: 250,
        height: 250,
      },
    },
    textH2: {
      width: '100%',
      color: 'white',
      fontFamily: 'Poppins',
      marginBottom: 5,
      textAlign: 'center',
      fontSize: '28px',
      textTransform: 'none',
      '@media only screen and (max-width: 600px)': {
        fontSize: '24px',
        marginBottom: 5,
        marginTop: 40,
      },
    },
    bodycenter: {
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%,-50%)',
      zIndex: 8,
    },
    flexData: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      '@media only screen and (max-width: 600px)': {
        justifyContent: 'flex-start',
      },
    },
    // Ajout styles pour la nouvelle maquette
    // desktopContainer: {
    //   minHeight: '100vh',
    //   padding: '40px 0',
    //   display: 'flex',
    //   flexDirection: 'column',
    //   alignItems: 'center', // centré horizontalement
    //   width: '100%',
    //   [theme.breakpoints.down('xs')]: {
    //     paddingTop: '10px !important',
    //   },
    // },
    // headerResultatTest: {
    //   marginLeft: 0,
    //   marginBottom: 24,
    //   display: 'flex',
    //   flexDirection: 'column',
    //   alignItems: 'flex-start',
    //   height: 'auto',
    //   justifyContent: 'flex-start',
    // },
    // resultatTestRed: {
    //   color: '#E63C3C',
    //   fontSize: 16,
    //   fontWeight: 400,
    //   textTransform: 'lowercase',
    //   marginBottom: 0,
    //   letterSpacing: 0.5,
    // },
    // resultatTestBlue: {
    //   color: '#001858',
    //   fontSize: 32,
    //   fontWeight: 800,
    //   marginTop: 0,
    //   lineHeight: 1.2,
    // },
    // mainContentRow: {
    //   display: 'flex',
    //   flexDirection: 'row',
    //   width: 1000, // largeur fixe
    //   maxWidth: '100%',
    //   justifyContent: 'center',
    //   alignItems: 'flex-start',
    //   gap: 48,
    //   marginLeft: 0, // plus de décalage
    // },
    // leftColImage: {
    //   flex: '0 0 45%',
    //   width: '45%',
    //   display: 'flex',
    //   flexDirection: 'column',
    //   alignItems: 'flex-start',
    //   justifyContent: 'flex-start',
    //   marginTop: 0,
    // },
    // resultImage: {
    //   width: '100%',
    //   height: 320,
    //   objectFit: 'cover',
    //   borderRadius: 0,
    //   boxShadow: '0 4px 24px rgba(0,0,0,0.07)',
    //   background: '#f5f6fa',
    // },
    // rightColContent: {
    //   flex: '0 0 55%',
    //   width: '55%',
    //   display: 'flex',
    //   flexDirection: 'column',
    //   alignItems: 'flex-start',
    //   justifyContent: 'flex-start',
    //   minWidth: 0,
    //   maxWidth: '100%',
    //   marginTop: 40,
    // },
    // diagramTitle: {
    //   color: '#001858',
    //   fontWeight: 700,
    //   fontSize: 20,
    //   marginTop: 0,
    //   textAlign: 'left',
    //   marginBottom: 10,
    // },
    // resultTextBlock: {},
    restitutionPageTitle: {
      fontFamily: 'Poppins',
      fontSize: 14,
      fontStyle: 'normal',
      fontWeight: 700,
      color: '#fff',
      textTransform: 'uppercase',
      marginTop: 25,
    },
    // Ajout styles pour la nouvelle maquette
    desktopContainer: {
      backgroundColor: '#F7F7FB',
      backgroundImage: 'url(/images/Background/background_test_v2.svg)',
      backgroundSize: 'cover',
      backgroundPosition: '0 0',
      backgroundRepeat: 'no-repeat',
      backgroundAttachment: 'fixed',
      width: '100%',
      maxWidth: '100%',
      paddingTop: '40px',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      overflowX: 'hidden',
      boxSizing: 'border-box', // centré horizontalement
      // MOBILE: Pas de padding horizontal pour éviter le scroll
      '@media only screen and (max-width: 600px)': {
        padding: '20px 0',
        alignItems: 'center',
        backgroundImage: 'none',
        backgroundColor: '#fff',
      },
    },
    headerResultatTest: {
      marginLeft: 0,
      marginBottom: 24,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
      height: 'auto',
      justifyContent: 'flex-start',
      width: '100%',
      // MOBILE: Aligné à gauche
      '@media only screen and (max-width: 600px)': {
        alignItems: 'flex-start',
        textAlign: 'left',
        marginBottom: 0,
        paddingBottom: 10,
        width: '100%',
      },
    },
    resultatTestRed: {
      color: '#E63C3C',
      fontSize: 16,
      fontWeight: 400,
      textTransform: 'lowercase',
      marginBottom: 0,
      letterSpacing: 0.5,
    },
    resultatTestBlue: {
      color: '#000A8C',
      fontSize: 26,
      fontWeight: 800,
      marginTop: 0,
      lineHeight: 1.2,
      // MOBILE: Taille adaptée et aligné à gauche
      '@media only screen and (max-width: 600px)': {
        fontSize: 26,
        textAlign: 'left',
      },
    },
    mainContentRow: {
      display: 'flex',
      flexDirection: 'row',
      width: 1000, // largeur fixe
      maxWidth: '100%',
      justifyContent: 'center',
      alignItems: 'flex-start',
      gap: 48,
      marginLeft: 0, // plus de décalage
      marginBottom: 20,
      // MOBILE: Structure verticale
      '@media only screen and (max-width: 600px)': {
        flexDirection: 'column',
        width: '100%',
        gap: 0,
        alignItems: 'center',
      },
    },
    leftColImage: {
      flex: '0 0 45%',
      width: '45%',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
      justifyContent: 'flex-start',
      marginTop: 0,
      // MOBILE: Masquer la colonne image
      '@media only screen and (max-width: 600px)': {
        display: 'none',
      },
    },
    resultImage: {
      width: '100%',
      height: 'auto',
      // objectFit: 'cover',
      borderRadius: 0,
      boxShadow: '0 4px 24px rgba(0,0,0,0.07)',
      background: '#f5f6fa',
      // MOBILE: Masquer la colonne image
      '@media only screen and (max-width: 600px)': {
        margin: '10px 0px',
        display: 'block',
      },
    },
    rightColContent: {
      flex: '0 0 55%',
      width: '55%',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
      justifyContent: 'flex-start',
      minWidth: 0,
      maxWidth: '100%',
      marginTop: 40,
      // MOBILE: Pleine largeur et aligné à gauche
      '@media only screen and (max-width: 600px)': {
        width: '100%',
        alignItems: 'flex-start',
        marginTop: 0,
      },
    },
    diagramTitle: {
      color: '#151528',
      fontWeight: 700,
      fontSize: 20,
      marginTop: 0,
      textAlign: 'left',
      marginBottom: 10,
      // MOBILE: Aligné à gauche avec marge interne, sans margin-bottom
      '@media only screen and (max-width: 600px)': {
        textAlign: 'left',
        fontSize: 18,
        marginBottom: 0,
        marginLeft: 16,
        marginRight: 16,
      },
    },
    resultTextBlock: {
      background: '#fff',
      border: '1px solid #E4E4E7',
      borderRadius: 6,
      padding: '16px 20px',
      marginTop: 20,
      marginBottom: 24,
      minHeight: 120,
      maxWidth: '100%',
      boxShadow: '0 2px 8px rgba(0,0,0,0.03)',
      position: 'relative',
      width: '100%',
      // MOBILE: Padding réduit pour éviter le scroll horizontal
      '@media only screen and (max-width: 600px)': {
        maxWidth: '100%',
        marginTop: 0,
        marginBottom: 0,
        padding: '16px 12px',
        boxSizing: 'border-box',
      },
    },
    noPaddingBottom: {
      '@media only screen and (max-width: 600px)': {
        paddingBottom: '0px !important',
      },
    },
    showMoreBtn: {
      color: '#001858',
      borderColor: '#001858',
      background: '#fff',
      fontWeight: 600,
      textTransform: 'none',
      float: 'right',
      marginTop: 8,
    },
    showLessBtn: {
      color: '#001858',
      background: 'transparent',
      fontWeight: 600,
      textTransform: 'none',
      float: 'right',
      marginTop: 8,
      textDecoration: 'underline',
    },
    shareDivider: {
      width: '100%',
      margin: '32px 0 16px 0',
      background: '#E0E0E0',
      height: 2,
      borderRadius: 1,
    },
    shareBlock: {
      width: '100%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: 16,
      padding: '10px 0',
      // MOBILE: Ajustement du layout
      '@media only screen and (max-width: 600px)': {
        flexDirection: 'column',
        gap: 16,
      },
    },
    newTestBtnContainer: {
      width: '100%',
      display: 'flex',
      justifyContent: 'center',
      marginTop: 32,
    },
    newTestBtn: {
      background: '#000A8C',
      color: '#fff',
      border: '2px solid #000A8C',
      borderRadius: 8,
      fontWeight: 700,
      fontSize: 16,
      textTransform: 'none',
      padding: '10px 32px',
      boxShadow: 'none',
      '&:hover': {
        background: '#001858',
        color: '#fff',
        borderColor: '#001858',
      },
    },
    showMoreBtnAbsolute: {
      position: 'absolute',
      left: '50%',
      transform: 'translateX(-50%)',
      bottom: 0,
      zIndex: 2,
      background: '#fff',
      textTransform: 'none',
      border: '1.5px solid #000A8C',
      whiteSpace: 'nowrap', // Empêche le retour à la ligne
      padding: '8px 16px', // Padding plus généreux
      minWidth: 'auto', // Largeur automatique
      '& span': {
        fontFamily: 'Poppins !important',
      },
      '@media only screen and (max-width: 600px)': {
        bottom: -18,
      },
    },
    resultText: {
      color: '#0E1247 !important',
      fontSize: 16,
      fontWeight: 400,
      lineHeight: 1.6,
      marginBottom: 16,
      whiteSpace: 'pre-line',
      '& p': {
        margin: '0 0 0px 0',
      },
      '& h1, & h2, & h3, & h4, & h5, & h6': {
        margin: '0 0 0px 0',
      },
      '& ul, & ol': {
        margin: '0 0 0px 0',
        paddingLeft: 20,
      },
      '& li': {
        margin: '0 0 4px 0',
      },
      '& p:empty, & p:has(br:only-child)': {
        fontSize: 10,
        lineHeight: 1,
        margin: 0,
      },
    },
    mainContentRow2: {
      width: '1000px',
      maxWidth: '100%',
      margin: '20px auto',
      [theme.breakpoints.down('xs')]: {
        margin: '10px auto',
        padding: '0px 15px',
        width: 'calc(100% - 30px)',
      },
    },
    contentAglomeration: {
      marginTop: 10,
      padding: '20px 40px',
      border: '1px solid #E4E4E7',
      borderRadius: 3,
      background: 'white',
    },
    numberWithText: {
      fontSize: 15,
      fontFamily: 'Poppins',
      fontWeight: 500,
      color: '#5763FF',
      display: 'flex',
      alignItems: 'center',
    },
    containerDiagram: {
      padding: '0px 20px',
    },
    titleBlocks: {
      fontWeight: 800,
      fontSize: 20,
      fontFamily: 'Poppins',
      color: '#151528',
    },
    containerAccordion: {
      padding: '0px 5px 5px',
      background: 'white',
      border: '1px solid #E4E4E7',
      borderRadius: 3,
    },
    shareContainerCustom: {
      width: '1000px',
      maxWidth: '100%',
      margin: '20px auto 40px auto',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      // MOBILE: Pleine largeur et centré
      '@media only screen and (max-width: 600px)': {
        width: '100%',
        margin: '32px 0 0 0',
      },
    },
    shareBorderTop: {
      width: '100%',
      borderTop: '1px solid #E4E4E7',
    },
    shareBorderBottom: {
      width: '100%',
      borderBottom: '1.5px solid #E0E0E0',
      marginTop: 5,
      marginBottom: 5,
    },
    shareTitle: {
      fontWeight: 800,
      fontSize: 14,
      color: '#18181B',
      fontFamily: 'Poppins, Arial, sans-serif',
    },
    heading: {
      fontSize: 18,
      fontFamily: 'Poppins !important',
      fontWeight: 700,
      color: '#000A8C',
    },
    subtitleBlocks: {
      fontWeight: 400,
      fontSize: 12,
      fontFamily: 'Poppins',
      color: '#5763FF',
      fontStyle: 'italic',
    },
    mainContentRow3: {
      display: 'flex',
      flexDirection: 'row',
      maxWidth: '100%',
      justifyContent: 'center',
      alignItems: 'flex-start',
      gap: 48,
      marginLeft: 24, // plus de décalage
    },
    titleVariable: {
      margin: 0,
      color: '#000A8C',
      fontWeight: 800,
      fontSize: 26,
      fontFamily: 'Poppins !important',
      '& *': {
        margin: '0px !important',
        fontFamily: 'Poppins !important',
        fontWeight: 700,
        color: '#000A8C',
      },
    },
    trait: {
      width: '100%',
      height: 2,
      background: '#E4E4E7',
      marginTop: 40,
      marginBottom: 40,
      [theme.breakpoints.down('xs')]: {
        marginTop: 20,
        marginBotton: 20,
      },
    },
    containerText: {
      [theme.breakpoints.down('xs')]: {
        paddingTop: '0px !important',
      },
    },
    textTitle: {
      color: '#000A8C',
      fontWeight: 800,
      fontSize: 32,
      marginTop: 20,
      [theme.breakpoints.down('xs')]: {
        paddingTop: '0px !important',
        marginTop: 10,
      },
    },
    // STYLES MOBILE AJOUTÉS
    mobileHeaderContainer: {
      display: 'none',
      '@media only screen and (max-width: 600px)': {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        textAlign: 'left',
        width: 'calc(100% - 32px)',
        marginBottom: 16,
        marginLeft: 16,
        marginRight: 16,
      },
    },
    mobileShareContainer: {
      display: 'none',
      '@media only screen and (max-width: 600px)': {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        width: 'calc(100% - 32px)',
        marginTop: 32,
        marginLeft: 16,
        marginRight: 16,
        paddingTop: 24,
        borderTop: '1px solid #E0E0E0',
        borderBottom: '1px solid #E0E0E0',
      },
    },
    mobileShareTitle: {
      fontWeight: 700,
      fontSize: 18,
      color: '#18181B',
      marginBottom: 16,
      textAlign: 'center',
    },
    mobileShareActions: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center',
      gap: 16,
      flexWrap: 'wrap',
    },
    titleMax: {
      color: '#000A8C',
      width: '100%',
      '-webkit-hyphens': 'auto',
      '-ms-hyphens': 'auto',
      hyphens: 'auto',
      wordBreak: 'break-word',
      fontWeight: 800,
      fontSize: 32,
      '& *': {
        color: '#000A8C',
        fontWeight: 800,
        fontSize: 32,
        fontFamily: 'Poppins',
        margin: '0px !important',
      },
      '@media only screen and (max-width: 600px)': {
        fontSize: 26,
        '& *': {
          fontSize: 26,
        },
      },
    },
    copyLinkButton: {
      '& span': {
        fontFamily: 'Poppins !important',
      },
    },
    besoinAideRow: {
      width: '100%',
      boxSizing: 'border-box',
      borderTop: '1px solid #E4E4E7',
      borderBottom: '1px solid #E4E4E7',
      padding: '16px 37px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: 40,
      cursor: 'pointer',
      '@media only screen and (max-width: 600px)': {
        padding: '16px 12px',
        gap: 16,
      },
    },
    besoinAideLabels: {
      display: 'flex',
      alignItems: 'center',
      flexWrap: 'wrap',
      gap: 12,
      flex: '1 1 auto',
      minWidth: 0,
    },
    besoinAideTitle: {
      fontWeight: 700,
      fontSize: 14,
      color: '#000A8D',
      fontFamily: 'Poppins, Arial, sans-serif',
      letterSpacing: '0.02em',
    },
    besoinAideContact: {
      fontWeight: 400,
      fontSize: 12,
      color: '#000000',
      fontFamily: 'Poppins, Arial, sans-serif',
      letterSpacing: '0.02em',
    },
    besoinAideIcon: {
      fontSize: 16,
      width: 16,
      height: 16,
      color: '#000000',
      flexShrink: 0,
    },
  })
);
